<template>
    <div class="p-2">
        <div class="d-md-flex flex-wrap">
            <div class="col-lg-12 col-md-2">
                <!-- Imput para que ingresen los valores -->
                <div class="d-lg-flex mt-2" v-if="origin !== 'report'">
                    <div class="col-lg col-md-12 mb-2 px-1 align-left" v-for="(sign, index) in vital_signs"
                        :key="index">
                        <div class="form-group d-lg-flex">
                            <label :for="'inputsing' + index" class="col-xl-5 col-lg-6 col-md-12 color-main fw-bold">{{
                                sign.label }}</label>
                            <div class="col-xl-7 col-lg-6 col-md-12" v-show="index !== 3">
                                <input type="text" v-model="sign.value" v-on:keypress="validateDecimal($event)"
                                    class="form-control form-control-input form-control-sm" :id="'inputsing' + index" />
                            </div>
                            <div class="col-xl-7 col-lg-6 col-md-12" v-show="index == 3">
                                <input type="text" v-model="cpValuePam" disabled
                                    class="form-control form-control-input form-control-sm" :id="'inputsing' + index" />
                            </div>
                        </div>
                    </div>
                    <div class="col-1 mb-2">
                        <button @click="mtdVerific()" class="btn btn-sm btn-success">
                            <i class="fas fa-save"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-lg-12 col-md-10">
                <div id="chart">
                    <apexchart type="line" ref="apexchart1" height="350" :options="chartOptions" :series="series">
                    </apexchart>
                </div>
            </div>
            <div>
            </div>
        </div>
        <SweetAlert :swal="swal" ref="SweetAlert"/>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';

export default {
    name: 'c-asistencial-sop-Grafico2Ficha',
    components: {
        apexchart: VueApexCharts,
        SweetAlert
    },
    data() {
        return {
            series: [],
            swal: null,
            chartOptions: {
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: true
                    },
                },

                dataLabels: {
                    enabled: false
                },
                stroke: {
                    width: 3,
                    curve: 'straight',
                    dashArray: [0, 4, 0, 2, 0, 1]
                },
                title: {
                    text: 'SIGNOS VITALES',
                    align: 'center'
                },
                legend: {
                    tooltipHoverFormatter: function (val, opts) {
                        return val + ' - <strong>' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '</strong>'
                    }
                },
                markers: {
                    size: 0,
                    hover: {
                        sizeOffset: 5
                    }
                },
                xaxis: {
                    categories: [],
                },
                tooltip: {
                    y: [
                        /* {
                                                    title: {
                                                        formatter: function (val) {
                                                            return val + " (mins)"
                                                        }
                                                    }
                                                },
                                                {
                                                    title: {
                                                        formatter: function (val) {
                                                            return val + " per session"
                                                        }
                                                    }
                                                }, */
                        {
                            title: {
                                formatter: function (val) {
                                    return val;
                                }
                            }
                        }
                    ]
                },
                grid: {
                    borderColor: '#f1f1f1',
                }

            },
            vital_signs: [{
                id: 1,
                label: 'EKG',
                value: null
            },
            {
                id: 2,
                label: 'PAS',
                value: null
            },
            {
                id: 3,
                label: 'PAD',
                value: null
            },
            {
                id: 4,
                label: 'PA',
                value: null
            },
            {
                id: 5,
                label: 'FC',
                value: null
            },
            {
                id: 6,
                label: 'FR',
                value: null
            },
            {
                id: 7,
                label: 'SpO2',
                value: null
            }
            ],
            hoursArray: [],
        };
    },
    props: {
        graphic: {
            type: Array,
            default: [],
        },
        origin: {
            type: String,
            default: ""
        }
    },
    watch: {
        graphic: {
            handler(newVal) {
                //console.log(newVal);
                if (newVal.length > 0) {
                    this.series = this.vital_signs
                        .filter((_, index) => index !== 3)
                        .map(sign => ({
                            name: sign.label,
                            data: newVal.map(item => item.data.find(v => v.label === sign.label).value)
                        }));

                    this.hoursArray = newVal.map(item => item.hour);
                    this.mtdChangeGraphic();
                }
            },
            deep: true
        }
    },
    computed: {
        cpValuePam() {
            let div = "";
            //obtener el promedio 
            let pas = this.vital_signs[1].value;
            let pad = this.vital_signs[2].value;
            if (pas && pad) {
                div = pas + "/" + pad;
            }
            return div;
        },
    },
    mounted() {
        this.series = this.vital_signs
            .filter((_, index) => index !== 3)
            .map(sign => ({
                name: sign.label,
                data: []
            }));
    },
    methods: {
        // Agregar un valor para la gráfica
        mtdAddGraphic() {
            const currentTime = new Date().toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit'
            });

            let itemGraphic = {
                hour: currentTime,
                data: this.vital_signs,
            };

            this.hoursArray.push(currentTime);

            // Añadir el valor del input de acuerdo al label
            this.vital_signs.forEach((element, index) => {
                if (index < 3) {
                    this.series[index].data.push(element.value);
                } else if (index > 3) {
                    this.series[index - 1].data.push(element.value);
                }
            });

            this.mtdChangeGraphic();
            this.$emit('mtdSaveGraphic', itemGraphic);
        },

        mtdVerific() {
            // Método para verificar que se hayan registrado valores
            this.vital_signs[3].value = this.cpValuePam;
            let hayCampoVacio = this.vital_signs.some(element => !element.value);
            if (hayCampoVacio) {
                // Si hay al menos un campo vacío, mostrar la alerta
                this.$refs.SweetAlert.showWarning('NO SE HA COMPLETADO TODOS LOS CAMPOS');
            } else {
                this.mtdAddGraphic();
            }
        },


        mtdChangeGraphic() {
            // Refrescar el gráfico
            this.chartOptions = {
                ...this.chartOptions,
                xaxis: {
                    ...this.chartOptions.xaxis,
                    categories: this.hoursArray // Eliminado el map innecesario
                }
            };

            this.$nextTick(() => {
                if (this.$refs.apexchart1) {
                    this.$refs.apexchart1.updateSeries(this.series);
                    this.$refs.apexchart1.updateOptions(this.chartOptions);
                }
            });

            this.hiddenInputs();
        },

        hiddenInputs() {
            this.vital_signs = [
                { id: 1, label: 'EKG', value: null },
                { id: 2, label: 'PAS', value: null },
                { id: 3, label: 'PAD', value: null },
                { id: 4, label: 'PA', value: null },
                { id: 5, label: 'FC', value: null },
                { id: 6, label: 'FR', value: null },
                { id: 7, label: 'SpO2', value: null }
            ];
        },

        validateDecimal(evt) {
            evt = evt || window.event;
            var charCode = evt.which || evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            }
        }
    }

};
</script>
